const SUMMARY_LENGTH = 150;

export const createAutomaticSummary = (text = '') => {
  const normalized = text.replace(/\s+/g, ' ').trim();
  const excerpt = normalized.slice(0, SUMMARY_LENGTH);
  return `${excerpt}${normalized.length > SUMMARY_LENGTH ? '…' : ''}`;
};

export const resolveArticleSummary = ({ articleText, summary, summaryEdited }) => {
  const manualSummary = summary.trim();
  return summaryEdited && manualSummary
    ? manualSummary
    : createAutomaticSummary(articleText);
};
